import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { loginAdmin } from '../redux/authSlice';
import { Loader2, Lock, User } from 'lucide-react';

const AdminLogin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form, setForm] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    const result = await dispatch(loginAdmin(form));
    setLoading(false);
    if (loginAdmin.fulfilled.match(result)) {
      navigate('/admin');
    } else {
      setError(result.payload || 'فشل تسجيل الدخول');
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4" dir="rtl">
      <div className="w-full max-w-sm bg-white border-2 border-gray-200 rounded-3xl p-8 space-y-6">

        <div className="text-center">
          <h1 className="text-2xl font-black text-emerald-600 tracking-tighter">BEN-MOUSSA</h1>
          <p className="text-xs font-bold text-gray-400 mt-1">لوحة التحكم — تسجيل الدخول</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="relative">
            <User size={15} className="absolute top-1/2 -translate-y-1/2 start-3.5 text-gray-400" />
            <input
              type="text"
              placeholder="اسم المستخدم"
              value={form.username}
              onChange={e => setForm({ ...form, username: e.target.value })}
              required
              className="w-full ps-10 pe-4 py-3 rounded-xl border-2 border-gray-200 focus:border-emerald-500 outline-none text-sm font-bold transition-all"
            />
          </div>

          <div className="relative">
            <Lock size={15} className="absolute top-1/2 -translate-y-1/2 start-3.5 text-gray-400" />
            <input
              type="password"
              placeholder="كلمة المرور"
              value={form.password}
              onChange={e => setForm({ ...form, password: e.target.value })}
              required
              className="w-full ps-10 pe-4 py-3 rounded-xl border-2 border-gray-200 focus:border-emerald-500 outline-none text-sm font-bold transition-all"
            />
          </div>

          {error && (
            <p className="text-xs font-bold text-red-500 text-center bg-red-50 border border-red-100 rounded-xl py-2.5 px-4">
              {error}
            </p>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full py-3.5 bg-emerald-600 text-white rounded-xl font-black text-sm hover:bg-emerald-700 transition-all disabled:opacity-50 flex items-center justify-center gap-2"
          >
            {loading ? <Loader2 size={16} className="animate-spin" /> : 'دخول'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
